import React, { useContext } from "react";
import PropTypes from "prop-types";
import { animated, useTransition } from "react-spring";
import ReactResizeDetector from "react-resize-detector";
import Block from "./Block";
import { DataContext } from "../../context/DataContext";
import ButtonBar from "../ButtonBar";
import { LEGEND_COLOR_BUTTON_SCHEMA } from "../../utils/constants";

const LegendColor = ({ title, colorScale, showLegend, valFormatter }) => {
  const { setColorLegendDims, changeMapKey, choroplethColorKey } = useContext(
    DataContext
  );
  const colors = colorScale.range();
  const colorRanges = colorScale.range().map((d) => colorScale.invertExtent(d));
  const transitions = useTransition(showLegend, null, {
    from: { top: "-100%", opacity: 0 },
    enter: { top: "0%", opacity: 1 },
    leave: { top: "-100%", opacity: 0 },
  });

  return transitions.map(
    ({ item, key, props }) =>
      item && (
        <animated.div
          key={key}
          style={props}
          className="legend-color__container-outer"
        >
          <ReactResizeDetector
            handleWidth
            handleHeight
            refreshMode="debounce"
            refreshRate={500}
            onResize={(width, height) => setColorLegendDims({ width, height })}
          >
            {({ targetRef }) => (
              <div className="legend-color__container-inner" ref={targetRef}>
                <ButtonBar
                  schema={LEGEND_COLOR_BUTTON_SCHEMA}
                  active={choroplethColorKey}
                  handleClick={changeMapKey}
                  small
                />
                <div className="legend-color__container-title">
                  <span>{title}</span>
                </div>
                <div className="legend-color__color-container">
                  {colors.map((color, idx) => {
                    const range = colorRanges[idx];
                    const value = range[0];
                    const hideText = false;
                    return (
                      <Block
                        key={color + value}
                        color={color}
                        value={value}
                        hideText={hideText}
                        valFormatter={valFormatter}
                      />
                    );
                  })}
                </div>
              </div>
            )}
          </ReactResizeDetector>
        </animated.div>
      )
  );
};

LegendColor.defaultProps = {
  valFormatter: null,
  small: false,
};

LegendColor.propTypes = {
  showLegend: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  colorScale: PropTypes.func.isRequired,
  valFormatter: PropTypes.func,
};

export default LegendColor;
